<template>
  <div class="module-item-wrap">
    <div class="tabs">
      <div class="item" @click="switchTab(item, index)"
            :class="tabActive === index ? 'active' : ''"
            v-for="(item, index) in tabList"
            :key="index"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="goods-list">
      <goodsList v-model="goodsInfo" @click="toGoodsDetail"></goodsList>
    </div>
  </div>
</template>

<script>
// import goodsItem from '@/modules/goodsItem'
import goodsList from '../goods-list'
export default {
  name: 'index',
  components: {
    // goodsItem
    goodsList
  },
  props: {
    isIOS: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      pageTabData: [{ indexAdList: [] }],
      tabList: [],
      goodsList: [],
      tabActive: 0,
      goodsInfo: {
        list: [],
        showPrice: true,
        showLabel: true,
        inlineNum: 2
      },
      actMatchList: {
        0: '优惠券',
        1: '折',
        2: '满减',
        3: '积分',
        4: '降价',
        5: '秒杀',
        6: '拼团'
      }
    }
  },
  created() {
  },
  mounted() {
    this.initTab()
  },
  methods: {
    switchTab (item, index) {
      this.tabActive = index
      this.goodsInfo.list = item.goodsList
    },
    setGoodsList (index) {
      this.goodsInfo.list = this.tabList[index].goodsList
    },
    initTab () {
      this.tabList = this.config.moduleData.tabList
      this.goodsInfo.inlineNum = this.config.moduleData.inlineNum

      if (this.tabList.length) {
        this.setGoodsList(this.tabActive)
      }
    },
    toGoodsDetail ({ data: goods }) {
      this.$constants.submitccLog('partner_mini_page_click', '首页商品点击', {
        commodity_id: goods.skuId,
        commodity_name: goods.title,
        goods_price: goods.shopPrice,
        original_price: goods.marketPrice,
        button_name: '首页点击商品',
        // user_type: this.isFormalEmp,
        user_empNo: this.empNo,
        page_name: '首页'
      })

      this.$router.push({
        name: 'goods-detail',
        query: { goodsId: goods.skuId }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
@import '../main.styl'
.tabs {
  //margin: 0 32rpx;
  display: flex;
  align-items: center;
  justify-content: center;

  .item {
    margin: 0 12px;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.6);
    line-height: 20px;
    position: relative;
    padding-bottom: 8px;
  }

  .active.item {
    font-size: 16px;
    color: #FC4C00;
  }

  .active::after {
    position: absolute;
    width: 60%;
    height: 3px;
    background: #ff5600;
    content: '';
    left: 20%;
    bottom: 0;
    border-radius: 12px;
  }
}

.goods-list {
  padding: 0px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1.6rem;
  .goods-item {
    background: #fff;
    width: calc(50vw - 22px);
    margin-bottom: 10px;
    overflow: hidden;
    border-radius: 8px;
    display: inline-block;
  }
}

</style>
